import { ActionWithCorrelationAttributes } from './correlation-actions';
import { Action } from '@ngrx/store';

export function withCorrelationIdOf(sourceAction, action: ActionWithCorrelationAttributes): Action {
  action.__correlationId = sourceAction.__correlationId;
  return action;
}
